import {PARTS_ACTIONS} from "./types";
import {addProcessing, removeProcessing} from "./processingActions";
import {
	PROC_PARTS_CREATE,
	PROC_PARTS_LIST,
	PROC_PARTS_UPDATE,
	PROC_PARTS_UPDATE_CHILDREN
} from "./index";
import {addError} from "./errorActions";
import {DELETE, GET, POST, PUT} from "ith-fetch";
import {getPartExpansionIndex} from "../misc/tree-handler";

const _setListRelations = (list, relations) => ({type: PARTS_ACTIONS.SET_LIST_RELATIONS, list, relations});
// const _setList = (list) => ({type: PARTS_ACTIONS.SET_LIST, list});
const _setOne = (part) => ({type: PARTS_ACTIONS.SET_ONE, part});
// const _removeOne = part => ({type: PARTS_ACTIONS.REMOVE_ONE, part});
// const _removeOneID = part_id => ({type: PARTS_ACTIONS.REMOVE_ONE, part_id});
const _setRelation = relation => ({type: PARTS_ACTIONS.SET_RELATION, relation});

export const expandPart = (expandIndex, expanded) => {
	expandIndex = typeof expandIndex === 'object' ? getPartExpansionIndex(expandIndex.path) : expandIndex;
	return {type: PARTS_ACTIONS.EXPAND, expandIndex, expanded};
};

export const loadParts = (force = false, onSuccess) =>
	async (dispatch) => {
		try {
			dispatch(addProcessing(PROC_PARTS_LIST));
			const result = await GET('/parts/all');
			console.info('RESULT IS', result);
			dispatch(_setListRelations(result.parts, result.p2p));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_PARTS_LIST));
		}
	};

export const createPart = (data, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_PARTS_CREATE));
			const part = await PUT('/parts', data);
			dispatch(_setOne({...part, root: true}));
			onSuccess && onSuccess(part);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_PARTS_CREATE));
		}
	};

export const deletePart = (part, onSuccess) =>
	async dispatch => {
		const delete_id = part.part_id || part;
		try {
			dispatch(addProcessing(PROC_PARTS_UPDATE, delete_id));
			const result = await DELETE(`/parts/${delete_id}`);
			// dispatch(_removeOne(result.deleted));
			dispatch(_setListRelations(result.parts, result.p2p));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_PARTS_UPDATE, delete_id));
		}
	};

export const updatePartRelationChildren = (parent_id, child_id, number_of_children, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_PARTS_UPDATE_CHILDREN, `${parent_id}-${child_id}`));
			const result = await POST('/parts/children', {parent_id, child_id, number_of_children});
			dispatch(_setRelation(result.relation));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_PARTS_UPDATE_CHILDREN,  `${parent_id}-${child_id}`));
		}
	};

export const updatePart = (data, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_PARTS_UPDATE, data.part_id));
			const result = await POST('/parts/update', data);
			dispatch(_setOne(result.part));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_PARTS_UPDATE, data.part_id));
		}
	};

const defaultMove = {part_id: 0, from: null, to: null, all_nodes: false};
export const movePart = (how = defaultMove, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_PARTS_UPDATE));
			how = {...defaultMove, ...how};
			const result = await POST('/parts/move', how);
			dispatch(_setListRelations(result.parts, result.p2p));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_PARTS_UPDATE));
		}
	};


// WEBPACK FOOTER //
// ./src/actions/partActions.js